import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Grid, TextField, Button, Typography, Divider, Select, MenuItem, InputLabel, FormControl, FormHelperText, Snackbar, Alert, InputAdornment, IconButton } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { fontSize, textAlign } from '../../../node_modules/@mui/system/index';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CreateBroker = () => {
  const [, setBrokers] = useState([]);

  const [isEmailAvailable, setIsEmailAvailable] = useState(true);
  const [emailError, setEmailError] = useState(null);

  const [updateMode, setUpdateMode] = useState(false);
    const navigate = useNavigate();
  
  // const [, setUserName] = useState('');
  // const [brokerId, setBrokerId] = useState(''); // Broker ID (auto-generated for new brokers)
  // const [fullName, setFullName] = useState('');
  // const [pointOfContact, setPointOfContact] = useState('');
  // const [secondaryPointOfContact, setSecondaryPointOfContact] = useState('');
  // const [, setPrimaryEmail] = useState('');
  // const [primaryContactNumber, setPrimaryContactNumber] = useState('');
  // const [, setSecondaryEmail] = useState('');
  // const [secondaryContactNumber, setSecondaryContactNumber] = useState('');
  // const [unitNumber, setUnitNumber] = useState('');
  // const [streetNumber, setStreetNumber] = useState('');
  // const [streetName, setStreetName] = useState('');
  // const [city, setCity] = useState('');
  // const [province, setProvince] = useState('');
  // const [country, setCountry] = useState('');
  // const [postalCode, setPostalCode] = useState('');

  const [primaryContactError, setPrimaryContactError] = useState('');
  // const [secondaryContactError, setSecondaryContactError] = useState('');

  const [primaryEmailError, setPrimaryEmailError] = useState('');
  // const [secondaryEmailError, setSecondaryEmailError] = useState('');

  const [primaryContactNumberError, setPrimaryContactNumberError] = useState('');
  // const [secondaryContactNumberError, setSecondaryContactNumberError] = useState('');

  const [usernameError, setUsernameError] = useState('');
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);

  const [loading, setLoading] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);
  // const [username, setUsername] = useState('');
  // const [password, setpassword] = useState('');
  const [role, setRole] = useState('Broker');
  // const [email, setemail] = useState('');
  // const [userStatus, setUserStatus] = useState('Inactive');

  // const [commission, setCommission] = useState('');
  const [, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  // const [selectedClient, setSelectedClient] = useState('');

  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [formData, setFormData] = useState({
    brokerID: ' ',
    brokerName: ' ',
    brokerStatus: 'Inactive',
    brokerComission: '',
    primaryContact: '',
    // secondaryContact: '',
    primaryEmail: '',
    // secondaryEmail: '',
    primaryContactNumber: '+1',
    // secondaryContactNumber: '+1',
    unitNumber: '',
    streetNumber: '',
    streetName: '',
    city: '',
    province: '',
    country: '',
    postalCode: '',
    username: '',
    password: '',
    role: 'Broker',
    email: '',
    userStatus: 'Inactive',
  });

  const [usernameInput] = useState(''); // Local input state for debouncing
  const [typingTimeout, setTypingTimeout] = useState(null);

  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword(prev => !prev);
  };



  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };

  const handleCountryChange = e => {
    const { value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      country: value,
      province: '', // Reset province when country changes
      postalCode: '', // Reset postal code when country changes
    }));
  };

  // Define the formatFieldName function at the top of the file or before handleSubmit
  const formatFieldName = field => {
    // This function formats the field name into a user-friendly string
    return field
      .replace(/([A-Z])/g, ' $1') // Insert space before uppercase letters
      .replace(/^./, str => str.toUpperCase()) // Capitalize the first letter
      .trim(); // Trim any extra spaces
  };

  const handleSubmit = async event => {
    event.preventDefault(); // Prevent the default form submission (page refresh)

    console.log('Form data before submitting:', formData); // Debug: Log the form data

    // Check for validation errors
    if (
      primaryContactError ||
      primaryEmailError ||
      primaryContactNumberError ||
      usernameError ||
      passwordError ||
      emailError
    ) {
      alert('Please fix the errors before submission');
      return;
    }

    // Check if all required fields are filled
    const requiredFields = [
      'brokerName',
      'brokerStatus',
      'primaryContact',
      // 'secondaryContact',
      'primaryEmail',
      // 'secondaryEmail',
      'primaryContactNumber',
      // 'secondaryContactNumber',
      // 'unitNumber',
      'streetNumber',
      'streetName',
      'city',
      'province',
      'country',
      'postalCode',
      'username',
      'email',
      'password',
      'role',
    ];

    for (const field of requiredFields) {
      const value = formData[field];
      if (!value || (typeof value === 'string' && value.trim() === '') || (Array.isArray(value) && value.length === 0)) {
        alert(`Please fill out the ${formatFieldName(field)} field.`);
        return;
      }
    }

    // Format the address correctly
    const addressComponents = [formData.unitNumber || '', formData.streetNumber, formData.streetName, formData.city, formData.province, formData.country, formData.postalCode];
    const address = addressComponents.filter(component => component).join(', ');

    // Prepare User Payload
    const userPayload = {
      userName: formData.username || '',
      emailId: formData.email || '',
      password: formData.password || '', // This should be hashed in real scenarios
      role: formData.role || 'User', // Default to "User"
      userStatus: formData.userStatus === 'Active',
      apiToken: formData.apiToken || 'default-api-token',
      resetToken: formData.resetToken || null,
      resetTokenExpiry: formData.resetTokenExpiry || null,
      updatedAt: new Date().toISOString(),
      brokerID: formData.brokerID,
    };

    console.log('User Payload Before Sending:', userPayload); // Debug: Log the user payload

    // Prepare Broker Payload
    const brokerPayload = {
      brokerID: formData.brokerID,
      brokerName: formData.brokerName,
      brokerComission: formData.brokerComission,
      brokerStatus: formData.brokerStatus === 'Active', // Ensure it's a boolean
      primaryContact: formData.primaryContact,
      // secondaryContact: formData.secondaryContact,
      primaryEmail: formData.primaryEmail,
      primaryContactNumber: formData.primaryContactNumber,
      // secondaryEmail: formData.secondaryEmail,
      // secondaryContactNumber: formData.secondaryContactNumber,
      address: address,
      unitNumber: formData.unitNumber,
      streetNumber: formData.streetNumber,
      streetName: formData.streetName,
      country: formData.country,
      city: formData.city,
      province: formData.province,
      postalCode: formData.postalCode,
    };

    console.log('Broker Payload:', brokerPayload); // Debug: Log the broker payload

    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${formData.apiToken}`, // Use the token if required
      };

      // First, send the request to add the user
      const userResponse = await fetch(`${BACKEND_URL}/v1/add-broker-user`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(userPayload),
      });

      // Check if the user response is ok
      if (!userResponse.ok) {
        let errorDetails = 'No error message available or malformed response';
        try {
          errorDetails = await userResponse.json();
          errorDetails = errorDetails.message || errorDetails.error || errorDetails;
        } catch (e) {
          console.error('Error parsing user response JSON:', e);
        }
        console.error('Failed to add user:', errorDetails);
        throw new Error(`Failed to add user: ${errorDetails}`);
      }

      // If the user is successfully created, send the request to add the broker
      const brokerResponse = await fetch(`${BACKEND_URL}/v1/brokers`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(brokerPayload),
      });

      // Check if the broker response is ok
      if (!brokerResponse.ok) {
        let errorDetails = 'No error message available or malformed response';
        try {
          errorDetails = await brokerResponse.json();
          errorDetails = errorDetails.message || errorDetails.error || errorDetails;
        } catch (e) {
          console.error('Error parsing broker response JSON:', e);
        }
        console.error('Failed to add broker:', errorDetails);
        throw new Error(`Failed to add broker: ${errorDetails}`);
      }

      const userResult = await userResponse.json();
      const brokerResult = await brokerResponse.json();

      console.log('User added successfully:', userResult);
      console.log('Broker added successfully:', brokerResult);

      // Fetch clients to check for assignment status using formData.brokerID
      const brokerClients = await fetchBrokerClients(formData.brokerID);

      // Now check if clients can be assigned
      // await handleAssignClient(formData.brokerID, brokerClients);

      // If everything is successful, reset the form data
      setFormData({
        brokerID: '',
        brokerName: '',
        brokerComission: '',
        brokerStatus: '',
        primaryContact: '',
        // secondaryContact: '',
        primaryEmail: '',
        primaryContactNumber: '+1',
        // secondaryEmail: '',
        // secondaryContactNumber: '+1',
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        city: '',
        province: '',
        country: '',
        postalCode: '',
        username: '',
        emailId: '',
        password: '',
        role: '',
        userStatus: 'Active',
        apiToken: '',
        currency: 'USD',
      });

      alert('Broker and User added successfully!');
    } catch (error) {
      console.error('Error:', error.message);
      alert('There was an error while adding the broker and user, or assigning clients. Please try again.');
    }
  };

  // Modified handleAssignClient function
  const handleAssignClient = async (brokerId, brokerClients) => {
    if (!brokerId || !selectedClients.length) {
      setSnackbarMessage('Please select both a broker and at least one client.');
      setSnackbarOpen(true);
      return;
    }

    console.log('Selected clients:', selectedClients);
    console.log('Broker ID:', brokerId);

    try {
      // Check if any of the selected clients are already assigned to the selected broker
      const isClientAlreadyAssigned = selectedClients.some(clientId => brokerClients.some(client => client.clientID === clientId));

      if (isClientAlreadyAssigned) {
        setSnackbarMessage('One or more clients are already assigned to this broker!');
        setSnackbarOpen(true);
        return;
      }

      // Send the list of selected clients (client IDs) as an array to the backend
      const assignClientResponse = await fetch(`${BACKEND_URL}/v1/broker/${brokerId}/clients`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(selectedClients), // Send selected client IDs as an array
      });

      if (!assignClientResponse.ok) {
        const errorMessage = await assignClientResponse.text();
        throw new Error(`Error assigning clients: ${assignClientResponse.status} ${assignClientResponse.statusText} - ${errorMessage}` + `\nPlease verify the client assignment request.`);
      }

      // Refresh brokers list to reflect changes
      await fetchBrokers();
      setSnackbarMessage('Clients assigned successfully!');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Error assigning clients:', error);
      setSnackbarMessage('An error occurred while assigning the clients.');
      setSnackbarOpen(true);
      throw error; // Prevent form submission
    }
  };

  // Fetch broker clients to check before assignment
  const fetchBrokerClients = async brokerId => {
    try {
      const response = await fetch(`${BACKEND_URL}/v1/broker/${brokerId}/clients`);

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Error fetching broker clients: ${response.status} ${response.statusText} - ${errorMessage}`);
      }

      const responseText = await response.text();
      if (!responseText) {
        throw new Error('Received empty response from the server');
      }

      const brokerClients = JSON.parse(responseText);
      if (brokerClients.length === 0) {
        console.log('No clients found for this broker.');
        return []; // Return an empty array if no clients are found
      }

      console.log('Broker Clients:', brokerClients);
      return brokerClients;
    } catch (error) {
      console.error('Error fetching broker clients:', error);
      setSnackbarMessage('An error occurred while fetching broker clients.');
      setSnackbarOpen(true);
      throw error; // Prevent form submission
    }
  };

  const validateContactNumber = number => {
    // Regular expression to validate a number starting with +1 followed by exactly 10 digits
    const phoneRegex = /^\+1\d{10}$/;
    return phoneRegex.test(number);
  };

  const handlePrimaryContactChange = e => {
    const newValue = e.target.value;
    handleInputChange(e); // Update form data

    // Validate primary contact number (should start with +1 and be followed by 10 digits)
    // if (newValue !== formData.secondaryContactNumber) {
    if (validateContactNumber(newValue)) {
      setPrimaryContactNumberError(''); // Clear error if valid
    } else {
      setPrimaryContactNumberError('Primary Contact Number must be a valid 10-digit number with country code (+1).');
    }
    // } else {
    //   setPrimaryContactNumberError('Primary and Secondary Contact Numbers must be different.');
    // }
  };

  // const handleSecondaryContactChange = (e) => {
  //   const newValue = e.target.value;
  //   handleInputChange(e); // Update form data

  //   // Validate secondary contact number (should start with +1 and be followed by 10 digits)
  //   if (newValue !== formData.primaryContactNumber) {
  //     if (validateContactNumber(newValue)) {
  //       setSecondaryContactNumberError(''); // Clear error if valid
  //     } else {
  //       setSecondaryContactNumberError(
  //         'Secondary Contact Number must be a valid 10-digit number with country code (+1).',
  //       );
  //     }
  //   } else {
  //     setSecondaryContactNumberError('Primary and Secondary Contact Numbers must be different.');
  //   }
  // };

  // Fetch the Broker ID when the component mounts
  useEffect(() => {
    fetchNextBrokerId();
  }, []); // Empty dependency array means this runs once on component mount

  // Fetching the broker list from the backend
  // Function to fetch brokers from the backend
  const fetchBrokers = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/v1/brokers`);

      // Check if the response was successful (status code 200-299)
      if (!response.ok) {
        throw new Error('Failed to fetch brokers'); // Throw error if the request was not successful
      }

      // Parse the response data
      const data = await response.json();

      // Update brokers state with the fetched data
      setBrokers(data);
    } catch (error) {
      // Set error message in case of an error
      setError(error.message);
    } finally {
      // Set loading to false when the fetching process completes
      setLoading(false);
    }
  };

  // Call fetchBrokers once when the component mounts
  useEffect(() => {
    fetchBrokers();
  }, []); // Empty dependency array ensures it only runs once on mount

  // Fetching the client list from the backend
  const fetchClients = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/v1/client`);
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Error fetching clients: ${response.status} ${response.statusText} - ${errorMessage}`);
      }
      const data = await response.json();
      setClients(data);
    } catch (error) {
      console.error('Error fetching clients:', error);
      setError(error.message);
    }
  };

  // Handle selection changes (multiple selections)
  const handleSelectChange = event => {
    setSelectedClients(event.target.value); // Update selected clients with an array of selected client IDs
  };

  const fetchNextBrokerId = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/v1/nextBrokerId`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch Broker ID: ${response.statusText}`);
      }

      const nextBrokerId = await response.json();
      console.log('Fetched next Broker ID:', nextBrokerId);

      setFormData(prevState => ({
        ...prevState,
        brokerID: nextBrokerId,
        xreferenceID: nextBrokerId,
        subfleetID: nextBrokerId,
      }));
    } catch (error) {
      console.error('Error fetching next Broker ID:', error);
    }
  };

  // Regular expression for password validation
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

  const validatePassword = () => {
    if (!passwordRegex.test(formData.password)) {
      setPasswordError('Password at least 8 char uppercase ,lowercase, number,special character.');
    } else {
      setPasswordError('');
    }
  };


  const handleInputChange = event => {
    const { name, value } = event.target;
    validateUsername(value);

    // If the field is 'brokerStatus', convert the value to boolean
    if (name === 'brokerStatus') {
      const booleanValue = value === 'Active'; // 'Active' becomes true, 'Inactive' becomes false
      setFormData({
        ...formData,
        [name]: booleanValue, // Update brokerStatus with true/false
      });

      // Handle Password validation (if applicable)
      if (name === 'password') {
        if (!passwordRegex.test(value)) {
          setPasswordError('Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character.');
        } else {
          setPasswordError(''); // Clear error if valid
        }
      }

      if (name === 'username') {
        // Check if username is empty or contains invalid characters, reset error in that case
        if (value.trim() === '') {
          setIsUsernameAvailable(true);
          setUsernameError(null); // Reset error when empty
        } else {
          checkUsernameExistence(value); // Call the username existence check API
        }
      }

      if (name === 'email') {
        // Step 1: Validate the email format
        if (validateEmail(value)) {
          setEmailError(''); // Clear error if email format is valid
          // Step 2: Check if email exists in the database
          checkEmailExistence(value);
        } else {
          setEmailError('Please enter a valid email address with a proper domain.');
          setIsEmailAvailable(true); // Don't check existence if format is invalid
        }
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // const handleEmailChange = (e) => {
  //   const email = e.target.value;
  //   console.log('Email input changed: ', email); // Log the current email input
  //   setFormData({ ...formData, email });

  //   // Only check availability after a certain length (e.g., 5 characters)
  //   if (email.length > 4) {
  //     checkEmailExistence(email);
  //   } else {
  //     setIsEmailAvailable(true);  // Assume email is available if too short
  //     setEmailError('');
  //   }
  // };

  const checkEmailExistence = async email => {
    try {
      const response = await fetch(`${BACKEND_URL}/v1/user?emailID=${email}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        // If the response is not OK (e.g., 404 or any error), assume email does not exist
        console.log(`Email ${email} does not exist (server error or not found).`);
        setIsEmailAvailable(true);
        setEmailError(null);
      } else {
        const data = await response.json();
        console.log('Response data: ', data); // Log the response data to check the email response

        // Check if the email is registered in the database by comparing the input email to the ones in the response
        const emailExists = data.some(user => user.email === email);

        if (emailExists) {
          console.log(`Email ${email} is already registered.`);
          setIsEmailAvailable(false);
          setEmailError('Email is already registered');
        } else {
          console.log(`Email ${email} is available.`);
          setIsEmailAvailable(true);
          setEmailError(null);
        }
      }
    } catch (error) {
      // If an error occurs (e.g., server error), handle accordingly
      console.log('Error checking email existence: ', error);
      setIsEmailAvailable(false);
      setEmailError('An error occurred while checking email availability');
    }
  };

  const validateUsername = username => {
    if (username === 'taken') {
      setIsUsernameAvailable(false);
      setUsernameError('This username is already taken');
    } else {
      setIsUsernameAvailable(true);
      setUsernameError('');
    }
  };

  // Debounced username existence check
  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout); // Clear previous timeout
    }
    if (usernameInput.trim()) {
      const newTimeout = setTimeout(() => {
        checkUsernameExistence(usernameInput);
      }, 500); // Debounce delay
      setTypingTimeout(newTimeout);
    } else {
      setIsUsernameAvailable(true);
      setUsernameError(null); // Reset error for empty input
    }
  }, [usernameInput]);

  const checkUsernameExistence = async username => {
    try {
      const response = await fetch(`${BACKEND_URL}/v1/user?username=${username}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        // Assume the username is available if there's an issue with the response
        setIsUsernameAvailable(true);
        setUsernameError(null);
      } else {
        const data = await response.json();
        if (Array.isArray(data) && data.length === 0) {
          // Username doesn't exist, no error
          setIsUsernameAvailable(true);
          setUsernameError(null);
        } else {
          // Username exists, show error
          setIsUsernameAvailable(false);
          setUsernameError('Username already exists');
        }
      }
    } catch (error) {
      // Handle any unexpected errors
      setIsUsernameAvailable(false);
      setUsernameError('An error occurred while checking username availability');
    }
  };

  const handleUsernameChange = e => {
    const username = e.target.value;
    setFormData({ ...formData, username });

    // Only check availability after a certain length (e.g., 3 characters)
    if (username.length > 3) {
      checkUsernameExistence(username);
    } else {
      setIsUsernameAvailable(true); // Assume username is available if too short
      setUsernameError('');
    }
  };

  // Email validation function
  const validateEmail = email => {
    // Regular expression to check for a valid email format with domain (must have '@' and a valid domain)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    fetchBrokers();
    fetchClients(); // Fetch clients on initial load
  }, []);

  // Fetching the users list
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/v1/user`);
        if (!response.ok) {
          const errorMessage = await response.text();
          throw new Error(`Error fetching users: ${response.status} ${response.statusText} - ${errorMessage}`);
        }
        const data = await response.json();
        const filteredData = data.filter(user => ['Broker'].includes(user.role));
        setUsers(filteredData);
      } catch (error) {
        console.error('Error fetching users:', error);
        setError(error.message);
      }
    };

    fetchUsers();
  }, []);

  // Function to auto-generate broker ID
  // const getNextBrokerId = () => {
  //   if (brokers.length === 0) {
  //     return 'FMS101'; // Start with FMS101 if no brokers exist
  //   }
  //   const ids = brokers.map((broker) => broker.id.replace('FMS', '')).map(Number); // Extract the number part from broker ID
  //   const maxId = Math.max(...ids); // Find the max ID number
  //   return `FMS${maxId + 1}`; // Generate the next ID
  // };

  // Handle change of selected user from dropdown
  // const handleUpdateUserSelectionChange = async (event) => {
  //   const selectedUserName = event.target.value;
  //   setUserName(selectedUserName);

  //   try {
  //     const response = await fetch(`${BACKEND_URL}/v1/user?username=${selectedUserName}`);
  //     if (!response.ok) {
  //       const errorMessage = await response.text();
  //       throw new Error(`Error fetching user details: ${response.status} ${response.statusText} - ${errorMessage}`);
  //     }
  //     const user = await response.json();
  //     setFirstName(user.firstName || '');
  //     setMiddleName(user.middleName || '');
  //     setLastName(user.lastName || '');
  //     setPrimaryEmailID(user.primaryEmailID || '');
  //     setSecondaryEmailID(user.secondaryEmailID || '');
  //     setAddress(user.address || '');
  //     //setCommission(user.commission || '');

  //     // If creating a new broker (not in update mode), generate a new broker ID
  //     if (!updateMode) {
  //       setBrokerId(getNextBrokerId());
  //     }
  //     setUpdateMode(true);
  //   } catch (error) {
  //     console.error('Error fetching user details:', error);
  //     setError(error.message);
  //   }
  // };

  // const handleAssignClient = async () => {
  //   if (!brokerId || !selectedClients.length) {
  //     setSnackbarMessage('Please select both a broker and at least one client.');
  //     setSnackbarOpen(true);
  //     return;
  //   }

  //   console.log('Selected clients:', selectedClients);
  //   console.log('Broker ID:', brokerId);

  //   try {
  //     // Fetch the list of all brokers
  //     const brokersResponse = await fetch(`${BACKEND_URL}/v1/brokers`);
  //     if (!brokersResponse.ok) {
  //       const errorMessage = await brokersResponse.text();
  //       throw new Error(
  //         `Error fetching brokers: ${brokersResponse.status} ${brokersResponse.statusText} - ${errorMessage}`,
  //       );
  //     }

  //     const allBrokers = await brokersResponse.json();
  //     console.log('All Brokers:', allBrokers);

  //     // Check if `allBrokers` is an array before using `.some()`
  //     if (!Array.isArray(allBrokers)) {
  //       throw new Error('The response for all brokers is not an array!');
  //     }

  //     // Check if any of the selected clients are already assigned to another broker
  //     const isClientAssignedElsewhere = selectedClients.some((clientId) =>
  //       allBrokers.some(
  //         (broker) =>
  //           broker.id !== brokerId &&
  //           Array.isArray(broker.clients) &&
  //           broker.clients.some((client) => client.clientID === clientId),
  //       ),
  //     );

  //     if (isClientAssignedElsewhere) {
  //       setSnackbarMessage('One or more clients are already assigned to another broker!');
  //       setSnackbarOpen(true);
  //       return;
  //     }

  //     // Fetch the clients of the selected broker
  //     const brokerClients = await fetchBrokerClients(brokerId);

  //     // Check if any of the selected clients are already assigned to the selected broker
  //     const isClientAlreadyAssigned = selectedClients.some((clientId) =>
  //       brokerClients.some((client) => client.clientID === clientId),
  //     );

  //     if (isClientAlreadyAssigned) {
  //       setSnackbarMessage('One or more clients are already assigned to this broker!');
  //       setSnackbarOpen(true);
  //       return;
  //     }

  //     // Send the list of selected clients (client IDs) as an array to the backend
  //     const assignClientResponse = await fetch(`${BACKEND_URL}/v1/broker/${brokerId}/clients`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(selectedClients), // Send selected client IDs as an array
  //     });

  //     if (!assignClientResponse.ok) {
  //       const errorMessage = await assignClientResponse.text();
  //       throw new Error(
  //         `Error assigning clients: ${assignClientResponse.status} ${assignClientResponse.statusText} - ${errorMessage}`,
  //       );
  //     }

  //     // Refresh brokers list to reflect changes
  //     await fetchBrokers();
  //     setSnackbarMessage('Clients assigned successfully!');
  //     setSnackbarOpen(true);
  //   } catch (error) {
  //     console.error('Error assigning clients:', error);
  //     setError(error.message);
  //     setSnackbarMessage('An error occurred while assigning the clients.');
  //     setSnackbarOpen(true);
  //   }
  // };

  // const fetchBrokerClients = async (brokerId) => {
  //   try {
  //     const response = await fetch(`${BACKEND_URL}/v1/broker/${brokerId}/clients`);

  //     if (!response.ok) {
  //       const errorMessage = await response.text();
  //       throw new Error(
  //         `Error fetching broker clients: ${response.status} ${response.statusText} - ${errorMessage}`,
  //       );
  //     }

  //     const responseText = await response.text();
  //     if (!responseText) {
  //       throw new Error('Received empty response from the server');
  //     }

  //     const brokerClients = JSON.parse(responseText);
  //     if (brokerClients.length === 0) {
  //       console.log('No clients found for this broker.');
  //       return []; // Return an empty array if no clients are found
  //     }

  //     console.log('Broker Clients:', brokerClients);
  //     return brokerClients;
  //   } catch (error) {
  //     console.error('Error fetching broker clients:', error);
  //     setSnackbarMessage('An error occurred while fetching broker clients.');
  //     setSnackbarOpen(true);
  //     throw error;
  //   }
  // };

  const handleBrokerStatusChange = e => {
    const value = e.target.value; // Get the selected value ('Active' or 'Inactive')
    setFormData({
      ...formData,
      brokerStatus: value, // Store 'Active' or 'Inactive' as a string
    });
  };
  const handleUserStatusChange = e => {
    const value = e.target.value; // Get the selected value ('Active' or 'Inactive')
    setFormData({
      ...formData,
      userStatus: value, // Store 'Active' or 'Inactive' as a string in formData
    });
  };

  // Reset form after creating/updating broker
  // const resetForm = () => {
  //   setUserName('');
  //   setBrokerId(''); // Reset brokerId
  //   setFirstName('');
  //   setMiddleName('');
  //   setLastName('');
  //   setPrimaryEmail('');
  //   setSecondaryEmail('');
  //   setAddress('');
  //   // setCommission('');
  //   setUpdateMode(false);
  // };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const inputStyles = {
    margin: '4px 0',
    minWidth: '180px',
  };
  return (
    <Box p={3}>
      {/* {loading && <CircularProgress />} */}
      {error && <Typography color="error">{error}</Typography>}
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: '14px',
          fontFamily: 'sans-serif',
          marginTop: '-15px',
          marginLeft: '20px',
          textTransform: 'uppercase',
        }}
      >
        Broker Management
      </Typography>

      {/* <Card variant="outlined" sx={{ mb: 4 }}> */}
      <CardContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Broker ID"
                name="brokerID"
                value={formData.brokerID} // This will update after fetching the Broker ID
                onChange={handleInputChange}
                disabled // Prevent manual editing
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                    marginTop: '14px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '10px',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Broker Name"
                name="brokerName" // Ensure this matches the state property
                value={formData.brokerName}
                onChange={handleInputChange}
                margin="normal"
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22, // Increased height for better visibility
                    minHeight: 22,
                    display: 'flex',
                    alignItems: 'center', // Ensures input content is centered
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 14,
                    padding: '10px', // Adjusted padding
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-10%', // Center label initially
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Broker Status"
                name="brokerStatus"
                value={formData.brokerStatus} // Use 'Active' or 'Inactive' directly
                onChange={handleBrokerStatusChange} // Custom handler for broker status change
                fullWidth
                required
                margin="normal"
                select
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-20%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              >
                <MenuItem style={{ fontSize: '11px' }} value="Active">Active</MenuItem>
                <MenuItem style={{ fontSize: '11px' }} value="Inactive">Inactive</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Primary Contact"
                name="primaryContact"
                value={formData.primaryContact}
                onChange={e => {
                  const newValue = e.target.value;
                  // Check if the value contains only alphabetic characters and is not a number
                  if (/\d/.test(newValue)) {
                    setPrimaryContactError('Primary Point of Contact cannot contain numbers.');
                  } else if (newValue !== formData.pointOfContact) {
                    setPrimaryContactError(''); // Clear error if valid
                    handleInputChange(e); // Update the formData if valid
                  } else {
                    // setPrimaryContactError(
                    //   'Point of Contact and Secondary Point of Contact should be different.',
                    // );
                  }
                }}
                error={!!primaryContactError} // Show error state if there's an error message
                helperText={primaryContactError} // Display the error message
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                    marginTop: '12px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '0%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                label="Secondary Contact"
                name="primaryContact"
                value={formData.primaryContact}
                onChange={(e) => {
                  const newValue = e.target.value;
                  // Check if the value contains only alphabetic characters and is not a number
                  if (/\d/.test(newValue)) {
                    setPrimaryContactError('Point of Contact cannot contain numbers.');
                  } else if (newValue !== formData.secondaryContact) {
                    setPrimaryContactError(''); // Clear error if valid
                    handleInputChange(e); // Update the formData if valid
                  } else {
                    setPrimaryContactError(
                      'Point of Contact and Secondary Point of Contact should be different.',
                    );
                  }
                }}
                error={!!primaryContactError} // Show error state if there's an error message
                helperText={primaryContactError} // Display the error message
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid> */}

            {/* Primary Email */}
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Primary Email"
                name="primaryEmail"
                value={formData.primaryEmail}
                onChange={e => {
                  const newValue = e.target.value;

                  // Update both fields: primaryEmail and email
                  setFormData(prev => ({
                    ...prev,
                    primaryEmail: newValue,
                    // Only autofill email if it was previously same as primary or empty
                    email: !prev.email || prev.email === prev.primaryEmail ? newValue : prev.email,
                  }));

                  // Validate email
                  if (validateEmail(newValue)) {
                    setPrimaryEmailError('');
                  } else {
                    setPrimaryEmailError('Primary Email must be a valid email address.');
                  }
                }}
                error={!!primaryEmailError}
                helperText={primaryEmailError}
                required
                sx={{
                  '& .MuiInputBase-root': { height: 22, minHeight: 22 },
                  '& .MuiInputBase-input': { fontSize: 11, padding: '5px' },
                }}
                InputLabelProps={{ sx: { fontSize: '10px', top: '-30%' } }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        textAlign: 'center',
                        padding: '7px 15px',
                        marginTop: '10px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                label="Primary Email"
                name="primaryEmail"
                value={formData.primaryEmail}
                onChange={(e) => {
                  const newValue = e.target.value;
                  // Update the form data first
                  handleInputChange(e);

                  // Check if primary email is different from secondary email
                  // if (newValue !== formData.secondaryEmail) {
                    if (validateEmail(newValue)) {
                      setPrimaryEmailError(''); // Clear error if valid
                    } else {
                      setPrimaryEmailError('Primary Email must be a valid email address.');
                    }
                  // } else {
                  //   setPrimaryEmailError('Primary Email and Secondary Email should be different.');
                  // }
                }}
                error={!!primaryEmailError} // Show error if there's an error message
                helperText={primaryEmailError} // Display the error message
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid> */}

            {/* Secondary Email */}
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                label="Secondary Email"
                name="secondaryEmail"
                value={formData.secondaryEmail}
                onChange={(e) => {
                  const newValue = e.target.value;
                  // Update the form data first
                  handleInputChange(e);

                  // Check if secondary email is different from primary email
                  if (newValue !== formData.primaryEmail) {
                    if (validateEmail(newValue)) {
                      setSecondaryEmailError(''); // Clear error if valid
                    } else {
                      setSecondaryEmailError('Secondary Email must be a valid email address.');
                    }
                  } else {
                    setSecondaryEmailError(
                      'Primary Email and Secondary Email should be different.',
                    );
                  }
                }}
                error={!!secondaryEmailError} // Show error if there's an error message
                helperText={secondaryEmailError} // Display the error message
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid> */}

            {/* Primary Contact Number */}
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Primary Contact Number"
                name="primaryContactNumber"
                value={formData.primaryContactNumber} // Bind to the state value for primary contact number
                onChange={handlePrimaryContactChange} // Use handlePrimaryContactChange
                error={!!primaryContactNumberError} // Show error if there's an error message
                helperText={primaryContactNumberError} // Display the error message
                required
                inputProps={{ maxLength: 12 }} // Total length = 13, i.e., "+1" + 10 digits
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* Secondary Contact Number */}
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                label="Secondary Contact Number"
                name="secondaryContactNumber"
                value={formData.secondaryContactNumber} // Bind to the state value for secondary contact number
                onChange={handleSecondaryContactChange} // Use handleSecondaryContactChange
                error={!!secondaryContactNumberError} // Show error if there's an error message
                helperText={secondaryContactNumberError} // Display the error message
                required
                inputProps={{ maxLength: 12 }} // Total length = 13, i.e., "+1" + 10 digits
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                    marginTop: '18px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '20px',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid> */}

            {/* Unit Number */}
            <Grid item xs={3}>
              <TextField
                label="Unit Number"
                name="unitNumber"
                value={formData.unitNumber}
                onChange={handleInputChange}
                fullWidth
                // margin="normal"
                type="number"
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* Street Number */}
            <Grid item xs={3}>
              <TextField
                label="Street Number"
                name="streetNumber"
                value={formData.streetNumber}
                onChange={handleInputChange}
                fullWidth
                required
                // margin="normal"
                type="number"
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* Street Name */}
            <Grid item xs={3} mt={1}>
              <TextField
                label="Street Name"
                name="streetName"
                value={formData.streetName}
                onChange={handleInputChange}
                fullWidth
                required
                // margin="normal"
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* City */}
            <Grid item xs={3} mt={1}>
              <TextField
                label="City"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                fullWidth
                required
                margin="normal"
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                    marginTop: '-15px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-400%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* Country */}
            <Grid item xs={3} mt={1}>
              <FormControl
                fullWidth
                size="small"
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
              >
                <InputLabel
                  sx={{
                    fontSize: '11px',
                    top: '-40%', // Initially center the label vertically
                  }}
                >
                  Country
                </InputLabel>
                <Select
                  name="country"
                  value={formData.country}
                  onChange={handleCountryChange}
                  label="Country"
                  required
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: '200px',
                        minHeight: '100px',
                        '& .MuiMenuItem-root': {
                          fontSize: '10px',
                          marginLeft: '5px',
                          padding: '5px 15px',
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="Canada">Canada</MenuItem>
                  <MenuItem value="United States">United States</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* Province */}
            {/* Province/State */}
            <Grid item xs={3} mt={1}>
              <TextField
                fullWidth
                label={formData.country === 'United States' ? 'State' : 'Province'}
                name="province"
                value={formData.province}
                onChange={handleInputChange}
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid>

            {/* Postal Code/Zip Code */}
            <Grid item xs={3}>
              <TextField
                fullWidth
                label={formData.country === 'United States' ? 'Zip Code' : 'Postal Code'}
                name="postalCode"
                value={formData.postalCode}
                onChange={e => {
                  const newPostalCode = e.target.value;
                  const country = formData.country;

                  // Validate based on selected country
                  if (country === 'Canada') {
                    // Canada postal code allows alphanumeric input (6 characters max)
                    if (newPostalCode.length <= 6) {
                      handleInputChange(e); // Only update the formData if it's 6 or fewer characters
                    }
                  } else if (country === 'United States') {
                    // US postal code should be numeric and 5 characters (or 9 with the extended ZIP+4 format)
                    if (/^\d*$/.test(newPostalCode) && newPostalCode.length <= 6) {
                      handleInputChange(e); // Only update the formData if it's 5 or fewer numeric characters
                    }
                  }
                }}
                required
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-50%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
                inputProps={{
                  maxLength: formData.country === 'United States' ? 9 : 6,
                }} // Adjust max length based on country
              />
            </Grid>
            {/* <Grid item xs={3}>
              <TextField
                label="Broker Commission"
                name="brokerComission"
                value={formData.brokerComission}
                onChange={handleInputChange}
                fullWidth
                required
                margin="normal"
                type="number" // Assuming broker commission is a number
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                    marginTop: '-17px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: '11px',
                    top: '-550%', // Initially center the label vertically
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: '200px',
                      minHeight: '100px',
                      '& .MuiMenuItem-root': {
                        fontSize: '10px',
                        marginLeft: '5px',
                        padding: '5px 15px',
                      },
                    },
                  },
                }}
              />
            </Grid> */}

            {/* <Grid item xs={3}>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  '& .MuiInputBase-root': {
                    height: 22,
                    minHeight: 22,
                  },
                  '& .MuiInputBase-input': {
                    fontSize: 11,
                    padding: '2px',
                  },
                }}
              >
                <InputLabel
                  id="clientDropdown"
                  sx={{
                    fontSize: '11px',
                    top: '-30%', // Initially center the label vertically
                  }}
                >
                  Select Client
                </InputLabel> */}

            {/* Display loading spinner while fetching */}
            {/* {loading ? (
                  <CircularProgress
                    size={24}
                    sx={{
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      display: 'block',
                    }}
                  />
                ) : error ? (
                  <Typography color="error" align="center">
                    {`Error: ${error}`}
                  </Typography>
                ) : (
                  <Select
                    labelId="clientDropdown"
                    id="clientDropdown"
                    value={selectedClients} // Value is now an array of selected client IDs
                    label="Select Client"
                    multiple // Enable multi-selection
                    onChange={handleSelectChange} // Update selected clients when user selects or deselects
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: '200px',
                          minHeight: '100px',
                          '& .MuiMenuItem-root': {
                            fontSize: '10px',
                            marginLeft: '5px',
                            padding: '5px 15px',
                          },
                        },
                      },
                    }}
                  >
                    {clients.map((client) => (
                      <MenuItem key={client.clientID} value={client.clientID}>
                        {`${client.clientID} - ${client.clientName}`}{' '} */}
            {/* Display both clientID and clientName */}
            {/* </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid> */}

            {/* Display selected clients below */}
            <Grid item xs={12}>
              {/* {selectedClients.length > 0 && (
                <Typography variant="subtitle1">Selected Clients:</Typography>
              )}
              <div>
                {selectedClients.map((clientID) => {
                  const client = clients.find((client) => client.clientID === clientID);
                  return (
                    client && (
                      <Chip
                        key={client.clientID}
                        label={`${client.clientID} - ${client.clientName}`}
                        sx={{ margin: '4px' }}
                      />
                    )
                  );
                })}
              </div> */}
            </Grid>

            <Typography variant="h6" textAlign="left" sx={{ mt: 10, mb: 4, pl: 2 }}></Typography>

            <Grid container spacing={2} alignItems="center">
              {/* Create User heading */}
              <Grid item xs={12} sx={{ ml: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    marginTop: '-110px',
                    fontFamily: 'sans-serif',
                    textTransform: 'uppercase',
                    fontSize: '13px',

                  }}
                >
                  Create User
                </Typography>
              </Grid>

              {/* Username */}
              <Grid item xs={3} sx={{ ml: 2, marginTop: '-130px' }}>
                <TextField
                  fullWidth
                  label="Username"
                  name="username"
                  value={formData.username}
                  onChange={handleUsernameChange}
                  required
                  error={!isUsernameAvailable} // Display error if username is not available
                  sx={{
                    '& .MuiInputBase-root': {
                      height: 22,
                      minHeight: 22,
                    },
                    '& .MuiInputBase-input': {
                      fontSize: 11,
                      padding: '2px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: '11px',
                      top: '-45%',
                    },
                  }}
                />
                {!isUsernameAvailable && usernameError && (
                  <FormHelperText error>{usernameError}</FormHelperText> // Display the error message
                )}
              </Grid>

              {/* Password */}
              <Grid item xs={3} sx={{ marginTop: '-130px' }}>
                <TextField
                  fullWidth
                  type={showPassword ? 'text' : 'password'} // Toggle between password and text type
                  label="Password"
                  name="password"
                  value={formData.password}
                  onChange={e => {
                    handleInputChange(e);
                    validatePassword();
                  }}
                  error={!!passwordError} // Show error if there's an error message
                  helperText={passwordError} // Display the error message
                  autoComplete="new-password" // Disable autofill for password
                  required
                  FormHelperTextProps={{
                    sx: { fontSize: '7px' } // Adjust the font size here (e.g., 0.75rem, 12px, etc.)
                  }}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: 22,
                      minHeight: 22,
                    },
                    '& .MuiInputBase-input': {
                      fontSize: 11,
                      padding: '2px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: '11px',
                      top: '-50%',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          sx={{
                            '& .MuiSvgIcon-root': {
                              fontSize: '16px', // Adjust the icon size
                            },
                            padding: '4px', // Reduce button padding if needed
                            fontSize: '8px',
                          }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {/* Role Dropdown (Admin) */}
              <Grid item xs={3} sx={{ marginTop: '-130px' }}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiInputBase-root': {
                      height: 22,
                      minHeight: 22,
                    },
                    '& .MuiInputBase-input': {
                      fontSize: 11,
                      padding: '2px',
                    },
                  }}
                >
                  <InputLabel
                    sx={{
                      fontSize: '11px',
                    }}
                  >
                    Role
                  </InputLabel>
                  <Select
                    value={role}
                    onChange={e => setRole(e.target.value)}
                    label="Role"
                    required
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: '50px',
                          minHeight: '30px',
                          '& .MuiMenuItem-root': {
                            fontSize: '10px',
                            marginLeft: '5px',
                            padding: '5px 15px',
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="Broker">Broker</MenuItem>
                    {/* Add other roles here if needed */}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3} sx={{ ml: 2, marginTop: '-40px' }}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  autoComplete="new-email" // Disable autofill for email
                  required
                  error={!isEmailAvailable} // Show error if the email is not available
                  sx={{
                    '& .MuiInputBase-root': {
                      height: 22,
                      minHeight: 22,
                    },
                    '& .MuiInputBase-input': {
                      fontSize: 11,
                      padding: '2px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: '11px',
                      top: '-30%',
                    },
                  }}
                />
                {!isEmailAvailable && <FormHelperText error>{emailError}</FormHelperText>}
              </Grid>

              {/* User Status Dropdown */}
              <Grid item xs={3} sx={{ marginTop: '-45px' }}>
                <TextField
                  label="User Status"
                  name="userStatus"
                  value={formData.userStatus} // Use 'Active' or 'Inactive' from formData
                  onChange={handleUserStatusChange} // Custom handler to update user status
                  fullWidth
                  margin="normal"
                  select
                  sx={{
                    '& .MuiInputBase-root': {
                      height: 22,
                      minHeight: 22,
                    },
                    '& .MuiInputBase-input': {
                      fontSize: 11,
                      padding: '2px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: '11px',
                    },
                  }}
                >
                  <MenuItem value="Active" sx={{ fontSize: '12px' }}>
                    Active
                  </MenuItem>
                  <MenuItem value="Inactive" sx={{ fontSize: '12px' }}>
                    Inactive
                  </MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Grid item xs={12} align="center">
              <Button
                style={{
                  marginTop: '-5px',
                  fontFamily: 'sans-serif',
                  fontSize: '10px',
                  backgroundColor: '#31478F',
                }}
                type="submit"
                size="small"
                variant="contained"
                sx={{ borderRadius: '5px' }}
              >
                {updateMode ? 'Update Broker' : 'Save Details'}
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  navigate('/manage-brokers/list');
                }}
                sx={{
                
                  ml: 2,
                  backgroundColor: '#E8F0FE',
                  fontSize:'10px',
                }}
              >
                Go Back
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
      {/* </Card> */}

      {/* <Grid item xs={12} align="center">
              <Button
                style={{
                  marginTop: '5px',
                  fontFamily: 'DM Sans',
                  fontSize: '16px',
                  backgroundColor: '#011f4b',
                }}
                variant="contained"
                onClick={handleAssignClient}
              >
                Assign Client
              </Button>
            </Grid> */}

      <Divider />

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateBroker;